import { CHANGE_USER_SESSION_STATUS, DELETE_USER_SESSION, SET_USER_SESSIONS, SET_USER_SESSIONS_SEARCH_VALUE, } from "../constants";
import { convertUserSessionFromServer } from "../utils/user-session";
const reducer = (state, action) => {
    var _a;
    switch (action.type) {
        case SET_USER_SESSIONS_SEARCH_VALUE: {
            return Object.assign(Object.assign({}, state), { sessionsSearchValue: (_a = action.payload) !== null && _a !== void 0 ? _a : "" });
        }
        case SET_USER_SESSIONS: {
            const userSessions = action.payload.map(convertUserSessionFromServer);
            return Object.assign(Object.assign({}, state), { userSessions });
        }
        case CHANGE_USER_SESSION_STATUS: {
            const { sessionId, status } = action.payload;
            return Object.assign(Object.assign({}, state), { userSessions: state.userSessions.map((session) => session.id === sessionId
                    ? Object.assign(Object.assign({}, session), { is_active: status }) : session) });
        }
        case DELETE_USER_SESSION: {
            const sessionId = action.payload;
            return Object.assign(Object.assign({}, state), { userSessions: state.userSessions.filter((session) => session.id !== sessionId) });
        }
        default: {
            return state;
        }
    }
};
export { reducer };
